import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { PressionPipe } from '../../../pipes/pression.pipe';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-p90-95',
  standalone: true,
  imports: [
    TraitementDataComponent,
    PressionPipe,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-p90-95.component.html',
  styleUrl: './traitement-data-p90-95.component.scss',
})
export class TraitementDataP9095Component {
  @Input() patient: Patient | undefined;
}
